import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

/* ── Iconos ──────────────────────────────────────────────── */
const iconProps = (size) => ({
  width: size, height: size, viewBox: '0 0 24 24', fill: 'none',
  stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round',
});

const IconSearch   = ({ size = 20 }) => (<svg {...iconProps(size)}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>);
const IconClose    = ({ size = 20 }) => (<svg {...iconProps(size)}><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>);
const IconCart     = ({ size = 20 }) => (<svg {...iconProps(size)}><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>);
const IconUser     = ({ size = 20 }) => (<svg {...iconProps(size)}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>);
const IconWhatsApp = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

/* ── Perfiles de usuario para navegación ─────────────────── */
const PERFILES_USUARIO = [
  { id: 'todos', label: 'Todos', valor: '' },
  { id: 'ninos', label: 'Niños', valor: 'Niños' },
  { id: 'mujer', label: 'Mujer', valor: 'Mujer' },
  { id: 'hombre', label: 'Hombre', valor: 'Hombre' },
  { id: 'adultos', label: 'Adultos Mayores', valor: 'Adultos Mayores' },
];

/* ── Modal de login de afiliado ──────────────────────────── */
const ModalLogin = ({ onClose, login }) => {
  const [codigo, setCodigo]     = useState('');
  const [error, setError]       = useState('');
  const [cargando, setCargando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setCargando(true);
    const res = await login(codigo);
    setCargando(false);
    if (res.ok) {
      onClose();
    } else {
      setError(res.error);
    }
  };

  return (
    <>
      {/* Overlay */}
      <div onClick={onClose} style={{
        position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 3000,
      }} />
      {/* Caja */}
      <div style={{
        position: 'fixed', top: '50%', left: '50%',
        transform: 'translate(-50%,-50%)',
        backgroundColor: 'var(--color-blanco)',
        borderRadius: 'var(--radius-lg)',
        boxShadow: 'var(--shadow-lg)',
        padding: 'var(--space-5)',
        width: 'min(360px, 90vw)',
        zIndex: 3001,
        fontFamily: 'var(--font-body)',
      }}>
        {/* Cabecera */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--space-4)' }}>
          <h3 style={{ margin: 0, fontFamily: 'var(--font-display)', fontSize: 'var(--font-size-h3)', fontWeight: 'var(--font-weight-black)', color: 'var(--text-primary)', letterSpacing: 'var(--letter-spacing-tight)' }}>
            Acceso afiliado
          </h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)', display: 'flex', padding: 4 }}>
            <IconClose size={18} />
          </button>
        </div>

        <p style={{ margin: '0 0 var(--space-3)', fontSize: 'var(--font-size-small)', color: 'var(--text-secondary)', lineHeight: 'var(--line-height-normal)' }}>
          Ingresa tu codigo de descuento para activar los precios de afiliado.
        </p>

        <form onSubmit={handleSubmit}>
          <input
            autoFocus
            type="text"
            placeholder="Cédula"
            value={codigo}
            onChange={(e) => { setCodigo(e.target.value.toUpperCase()); setError(''); }}
            style={{
              width: '100%', boxSizing: 'border-box',
              padding: '10px 14px',
              borderRadius: 'var(--radius-md)',
              border: error ? '1.5px solid #e02424' : '1px solid var(--border-default)',
              backgroundColor: 'var(--color-gris-fondo)',
              fontSize: 'var(--font-size-small)',
              fontFamily: 'var(--font-body)',
              color: 'var(--text-primary)',
              outline: 'none',
              letterSpacing: '0.05em',
              marginBottom: 'var(--space-2)',
            }}
          />
          {error && (
            <p style={{ margin: '0 0 var(--space-3)', fontSize: 'var(--font-size-xs)', color: '#e02424' }}>{error}</p>
          )}
          <button
            type="submit"
            disabled={cargando || !codigo.trim()}
            style={{
              width: '100%', padding: '11px',
              backgroundColor: cargando || !codigo.trim() ? 'var(--color-gris-bd)' : 'var(--color-verde)',
              color: 'var(--color-blanco)', border: 'none',
              borderRadius: 'var(--radius-md)', cursor: cargando || !codigo.trim() ? 'default' : 'pointer',
              fontFamily: 'var(--font-body)', fontSize: 'var(--font-size-small)',
              fontWeight: 'var(--font-weight-medium)',
              transition: 'background-color var(--transition-fast)',
            }}
          >
            {cargando ? 'Verificando...' : 'Ingresar'}
          </button>
        </form>
      </div>
    </>
  );
};

/* ── Menú de usuario ─────────────────────────────────────── */
const MenuUsuario = ({ afiliado, vistaAfiliado, setVistaAfiliado, logout, onLoginClick, onClose }) => {
  const WA_AFILIACION = `https://wa.me/593993334684?text=${encodeURIComponent('Quiero ser afiliado')}`;

  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 1100 }} />
      <div style={{
        position: 'absolute', top: 'calc(100% + 8px)', right: 0,
        backgroundColor: 'var(--color-blanco)',
        border: '1px solid var(--border-default)',
        borderRadius: 'var(--radius-lg)',
        boxShadow: 'var(--shadow-lg)',
        minWidth: '220px',
        zIndex: 1200,
        fontFamily: 'var(--font-body)',
        overflow: 'hidden',
      }}>
        {afiliado ? (
          <>
            {/* Saludo */}
            <div style={{ padding: 'var(--space-3) var(--space-4)', borderBottom: '1px solid var(--border-default)', backgroundColor: 'var(--color-gris-fondo)' }}>
              <p style={{ margin: 0, fontSize: 'var(--font-size-xs)', color: 'var(--text-muted)' }}>Bienvenido,</p>
              <p style={{ margin: 0, fontSize: 'var(--font-size-small)', fontWeight: 'var(--font-weight-medium)', color: 'var(--text-primary)' }}>{afiliado.nombre}</p>
            </div>

            {/* Vista afiliado */}
            <button
              onClick={() => { setVistaAfiliado(true); onClose(); }}
              style={menuBtnStyle(vistaAfiliado)}
            >
              <span style={{ fontSize: '15px' }}>🏷️</span>
              Vista afiliado
              {vistaAfiliado && <span style={{ marginLeft: 'auto', color: 'var(--color-verde)', fontSize: 11, fontWeight: 600 }}>ACTIVA</span>}
            </button>

            {/* Vista cliente */}
            <button
              onClick={() => { setVistaAfiliado(false); onClose(); }}
              style={menuBtnStyle(!vistaAfiliado)}
            >
              <span style={{ fontSize: '15px' }}>👁️</span>
              Vista cliente
              {!vistaAfiliado && <span style={{ marginLeft: 'auto', color: 'var(--color-verde)', fontSize: 11, fontWeight: 600 }}>ACTIVA</span>}
            </button>

            {/* Salir */}
            <button
              onClick={() => { logout(); onClose(); }}
              style={{ ...menuBtnStyle(false), color: '#e02424', borderTop: '1px solid var(--border-default)', marginTop: 4 }}
            >
              <span style={{ fontSize: '15px' }}>🚪</span>
              Salir
            </button>
          </>
        ) : (
          <>
            {/* Ingresar codigo */}
            <button onClick={() => { onLoginClick(); onClose(); }} style={menuBtnStyle(false)}>
              <span style={{ fontSize: '15px' }}>🔑</span>
              Ingresar codigo
            </button>

            {/* Solicitar afiliacion */}
            <a
              href={WA_AFILIACION}
              target="_blank"
              rel="noopener noreferrer"
              style={{ ...menuBtnStyle(false), textDecoration: 'none', color: 'var(--color-verde)', display: 'flex', alignItems: 'center', gap: 'var(--space-2)', cursor: 'pointer' }}
              onClick={onClose}
            >
              <span style={{ fontSize: '15px' }}>📋</span>
              Solicitar afiliacion
            </a>
          </>
        )}
      </div>
    </>
  );
};

const menuBtnStyle = (_active) => ({
  width: '100%', display: 'flex', alignItems: 'center', gap: 'var(--space-2)',
  padding: 'var(--space-3) var(--space-4)',
  background: 'none', border: 'none', cursor: 'pointer',
  fontSize: 'var(--font-size-small)', fontWeight: 'var(--font-weight-regular)',
  fontFamily: 'var(--font-body)', color: 'var(--text-primary)', textAlign: 'left',
  transition: 'background-color var(--transition-fast)',
});

/* ── Header principal ────────────────────────────────────── */
const Header = ({ searchQuery, setSearchQuery, cartItems = [], onCartClick,
                  afiliado, vistaAfiliado, setVistaAfiliado, login, logout }) => {
  const location        = useLocation();
  const navigate        = useNavigate();
  const mostrarBusqueda = location.pathname === '/';
  const [searchAbierto, setSearchAbierto] = useState(false);
  const [menuAbierto, setMenuAbierto]     = useState(false);
  const [modalLogin, setModalLogin]       = useState(false);
  const menuRef = useRef(null);

  const cantidadTotal = cartItems.reduce((acc, item) => acc + (item.cantidad || 1), 0);
  const [animarCarrito, setAnimarCarrito] = useState(false);
  const cantidadPrevia = useRef(cantidadTotal);

  useEffect(() => {
    if (cantidadTotal > cantidadPrevia.current) {
      setAnimarCarrito(true);
      const t = setTimeout(() => setAnimarCarrito(false), 500);
      return () => clearTimeout(t);
    }
    cantidadPrevia.current = cantidadTotal;
  }, [cantidadTotal]);

  useEffect(() => { cantidadPrevia.current = cantidadTotal; }, [animarCarrito, cantidadTotal]);

  const abrirSearch = () => {
    setSearchAbierto(true);
    setTimeout(() => document.getElementById('search-input')?.focus(), 50);
  };
  const cerrarSearch = () => {
    setSearchAbierto(false);
    setSearchQuery('');
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (location.pathname !== '/') {
        navigate('/');
      }
    }
  };

  /* Selección de perfiles de usuario */
  const handleSelectPerfil = (tipoNombre) => {
    if (location.pathname !== '/') {
      navigate('/');
    }
    if (tipoNombre === '') {
      setSearchQuery('');
    } else if (searchQuery && searchQuery.trim().toLowerCase() === tipoNombre.trim().toLowerCase()) {
      setSearchQuery('');
    } else {
      setSearchQuery(tipoNombre);
    }
  };

  const isPerfilActivo = (item) => {
    if (item.valor === '') {
      return !searchQuery;
    }
    return Boolean(
      searchQuery &&
      searchQuery.trim().toLowerCase() === item.valor.trim().toLowerCase()
    );
  };

  return (
    <>
      <header style={{
        backgroundColor: 'var(--color-blanco)',
        borderBottom: '1px solid var(--border-default)',
        position: 'sticky', top: 0, zIndex: 1000,
        fontFamily: 'var(--font-body)',
      }}>
        {/* Banda afiliado activa */}
        {afiliado && vistaAfiliado && (
          <div style={{
            backgroundColor: 'var(--color-verde)', color: 'var(--color-blanco)',
            textAlign: 'center', padding: '4px 0',
            fontSize: 'var(--font-size-label)', fontWeight: 'var(--font-weight-medium)',
            letterSpacing: 'var(--letter-spacing-wide)',
          }}>
            🏷️ Modo afiliado activo — 25% de descuento en todo el catalogo
          </div>
        )}

        {/* Fila principal */}
        <div style={{
          maxWidth: 'var(--max-width)', margin: '0 auto',
          padding: '0 var(--space-4)',
          height: 'var(--header-height-desktop)',
          display: 'flex', alignItems: 'center', gap: 'clamp(10px, 3vw, 16px)',
        }}>
          {/* Logo */}
          <Link to="/" style={{ textDecoration: 'none', flexShrink: 0 }}>
            <span style={{
              fontFamily: 'var(--font-display)', fontWeight: 'var(--font-weight-black)',
              fontSize: '1.35rem', color: 'var(--color-negro)',
              letterSpacing: 'var(--letter-spacing-tight)', lineHeight: 1,
            }}>
              HOREB <span style={{ color: 'var(--color-negro)' }}>LIFE</span>
            </span>
          </Link>

          {/* Busqueda desktop limpia */}
          {mostrarBusqueda && (
            <div className="search-desktop" style={{ flex: 1, maxWidth: '420px', position: 'relative' }}>
              <span style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: 'var(--color-gris-light)', display: 'flex' }}>
                <IconSearch size={16} />
              </span>
              <input
                type="text"
                placeholder="Buscar productos..."
                value={searchQuery}
                onFocus={(e) => {
                  e.target.style.borderColor = 'var(--color-verde)';
                  e.target.style.backgroundColor = 'var(--color-blanco)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = 'var(--border-default)';
                  e.target.style.backgroundColor = 'var(--color-gris-fondo)';
                }}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={handleSearchKeyDown}
                style={{
                  width: '100%', padding: '8px 36px 8px 36px',
                  borderRadius: 'var(--radius-pill)', border: '1px solid var(--border-default)',
                  backgroundColor: 'var(--color-gris-fondo)', color: 'var(--color-negro)',
                  fontSize: 'var(--font-size-small)', fontFamily: 'var(--font-body)',
                  fontWeight: 'var(--font-weight-regular)', outline: 'none',
                  transition: 'border-color var(--transition-fast), background-color var(--transition-fast)',
                }}
              />
              {searchQuery && (
                <button onClick={() => setSearchQuery('')} aria-label="Limpiar busqueda" style={{
                  position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)',
                  border: 'none', background: 'none', color: 'var(--color-gris-mid)',
                  lineHeight: 1, cursor: 'pointer', padding: '2px 4px', display: 'flex',
                }}><IconClose size={14} /></button>
              )}
            </div>
          )}

          <div style={{ flex: 1 }} />

          {/* Lupa movil */}
          {mostrarBusqueda && (
            <button className="search-icon-mobile header-icon-btn" onClick={abrirSearch} aria-label="Abrir busqueda" style={{ display: 'none' }}>
              <IconSearch size={20} />
            </button>
          )}

          {/* WhatsApp */}
          <a href="https://wa.me/593993334684" target="_blank" rel="noopener noreferrer"
            className="wa-btn header-icon-btn"
            style={{ textDecoration: 'none' }}
          >
            <span style={{ display: 'flex' }}>
              <IconWhatsApp size={18} />
            </span>
            <span className="wa-texto" style={{
              fontSize: 'var(--font-size-xs)', fontWeight: 'var(--font-weight-medium)',
              letterSpacing: '0.01em',
            }}>Pedir por WhatsApp</span>
          </a>

          {/* Icono usuario */}
          <div ref={menuRef} style={{ position: 'relative', flexShrink: 0 }}>
            <button
              onClick={() => setMenuAbierto(v => !v)}
              aria-label="Menu de usuario"
              className="header-icon-btn"
            >
              <IconUser size={20} />
              {afiliado && (
                <span style={{
                  position: 'absolute', bottom: '4px', right: '4px',
                  width: '8px', height: '8px', borderRadius: '50%',
                  backgroundColor: 'var(--color-verde)',
                  border: '1.5px solid var(--color-blanco)',
                  boxSizing: 'content-box',
                }} />
              )}
            </button>

            {menuAbierto && (
              <MenuUsuario
                afiliado={afiliado}
                vistaAfiliado={vistaAfiliado}
                setVistaAfiliado={setVistaAfiliado}
                logout={logout}
                onLoginClick={() => setModalLogin(true)}
                onClose={() => setMenuAbierto(false)}
              />
            )}
          </div>

          {/* Carrito */}
          <button
            type="button" onClick={onCartClick}
            aria-label={`Abrir carrito${cantidadTotal > 0 ? `, ${cantidadTotal} productos` : ''}`}
            className={`header-icon-btn${animarCarrito ? ' cart-bounce' : ''}`}
          >
            <IconCart size={20} />
            {cantidadTotal > 0 && (
              <span style={{
                position: 'absolute', top: '2px', right: '0px',
                minWidth: '16px', height: '16px',
                borderRadius: 'var(--radius-pill)', backgroundColor: '#e02424',
                color: '#fff', fontSize: '10px', fontWeight: 'var(--font-weight-medium)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                padding: '0 4px', border: '2px solid var(--color-blanco)',
                boxSizing: 'content-box', lineHeight: 1,
              }}>
                {cantidadTotal > 99 ? '99+' : cantidadTotal}
              </span>
            )}
          </button>
        </div>

        {/* Busqueda movil expandible */}
        {mostrarBusqueda && searchAbierto && (
          <div style={{ padding: 'var(--space-3) var(--space-4)', borderTop: '1px solid var(--border-default)', display: 'none' }} className="search-mobile-bar">
            <div style={{ position: 'relative' }}>
              <span style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: 'var(--color-gris-light)', display: 'flex' }}>
                <IconSearch size={16} />
              </span>
              <input
                id="search-input" type="text" placeholder="Buscar productos..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={handleSearchKeyDown}
                style={{
                  width: '100%', padding: '9px 40px 9px 36px',
                  borderRadius: 'var(--radius-pill)', border: '1px solid var(--color-verde)',
                  backgroundColor: 'var(--color-blanco)', color: 'var(--color-negro)',
                  fontSize: 'var(--font-size-small)', fontFamily: 'var(--font-body)', outline: 'none',
                }}
              />
              <button onClick={cerrarSearch} aria-label="Cerrar busqueda" style={{
                position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)',
                border: 'none', background: 'none', color: 'var(--color-gris-mid)',
                lineHeight: 1, cursor: 'pointer', padding: '2px 4px', display: 'flex',
              }}><IconClose size={16} /></button>
            </div>
          </div>
        )}

        {/* Menú superior de perfiles / tipos de usuario */}
        <nav
          aria-label="Filtro por tipo de usuario"
          style={{
            borderTop: '1px solid var(--border-default)',
            backgroundColor: 'var(--color-blanco)',
          }}
        >
          <div
            className="perfiles-bar-scroll"
            style={{
              maxWidth: 'var(--max-width)',
              margin: '0 auto',
              padding: '8px var(--space-4)',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              overflowX: 'auto',
              WebkitOverflowScrolling: 'touch',
            }}
          >
            {PERFILES_USUARIO.map((item) => {
              const activo = isPerfilActivo(item);
              return (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => handleSelectPerfil(item.valor)}
                  className={`perfil-chip ${activo ? 'perfil-chip-activo' : ''}`}
                  style={{
                    flexShrink: 0,
                    padding: '6px 14px',
                    borderRadius: 'var(--radius-pill)',
                    border: activo
                      ? '1.5px solid var(--color-verde)'
                      : '1px solid var(--border-default)',
                    backgroundColor: activo
                      ? 'var(--color-verde-tint)'
                      : 'var(--color-gris-fondo)',
                    color: activo
                      ? 'var(--color-verde)'
                      : 'var(--text-secondary)',
                    fontFamily: 'var(--font-body)',
                    fontSize: 'var(--font-size-xs)',
                    fontWeight: activo ? 600 : 'var(--font-weight-medium)',
                    cursor: 'pointer',
                    transition: 'all var(--transition-fast)',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                    whiteSpace: 'nowrap',
                    lineHeight: 1.2,
                    boxShadow: activo ? '0 1px 4px rgba(74, 156, 63, 0.15)' : 'none',
                    WebkitTapHighlightColor: 'transparent',
                  }}
                  onMouseEnter={(e) => {
                    if (!activo) {
                      e.currentTarget.style.backgroundColor = '#eaeae7';
                      e.currentTarget.style.color = 'var(--text-primary)';
                      e.currentTarget.style.borderColor = 'var(--color-gris-light)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!activo) {
                      e.currentTarget.style.backgroundColor = 'var(--color-gris-fondo)';
                      e.currentTarget.style.color = 'var(--text-secondary)';
                      e.currentTarget.style.borderColor = 'var(--border-default)';
                    }
                  }}
                  aria-pressed={activo}
                >
                  {item.label}
                </button>
              );
            })}
          </div>
        </nav>

        <style>{`
          header input[type="text"]::placeholder { color: var(--color-gris-light); font-family: var(--font-body); }

          /* ── Botón de ícono unificado ─────────────────────── */
          .header-icon-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            min-width: 40px;
            min-height: 40px;
            border-radius: 50%;
            background: transparent;
            border: none;
            cursor: pointer;
            color: var(--text-primary);
            flex-shrink: 0;
            padding: 0;
            position: relative;
            -webkit-tap-highlight-color: transparent;
            transition: background-color var(--transition-fast), color var(--transition-fast);
          }
          .header-icon-btn:hover {
            background-color: var(--color-gris-fondo);
          }
          .header-icon-btn:active {
            background-color: var(--color-gris-bd);
          }

          /* ── WA: estilo pill con texto en desktop ────────── */
          .wa-btn.header-icon-btn {
            width: auto;
            height: auto;
            min-width: unset;
            padding: 7px 16px;
            border-radius: var(--radius-pill);
            border: 1px solid var(--border-default);
            gap: var(--space-2);
          }
          .wa-btn.header-icon-btn:hover {
            background-color: var(--color-gris-fondo);
            border-color: var(--color-gris-light);
          }

          @keyframes cart-bounce {
            0%   { transform: scale(1); }
            25%  { transform: scale(1.25) rotate(-6deg); }
            50%  { transform: scale(0.95) rotate(4deg); }
            75%  { transform: scale(1.1); }
            100% { transform: scale(1); }
          }
          .cart-bounce { animation: cart-bounce 0.5s ease; }

          .perfiles-bar-scroll::-webkit-scrollbar { display: none; }
          .perfiles-bar-scroll { -ms-overflow-style: none; scrollbar-width: none; }

          @media (max-width: 600px) {
            .search-desktop     { display: none !important; }
            .search-icon-mobile { display: flex !important; }
            .search-mobile-bar  { display: block !important; }
            .wa-texto           { display: none; }
            /* WA se convierte en botón de ícono circular en móvil */
            .wa-btn.header-icon-btn {
              width: 40px;
              height: 40px;
              min-width: 40px;
              padding: 0;
              border: none;
              border-radius: 50%;
              justify-content: center;
            }
          }
        `}</style>
      </header>

      {/* Modal login */}
      {modalLogin && <ModalLogin onClose={() => setModalLogin(false)} login={login} />}
    </>
  );
};

export default Header;
